import { createContext } from "react";

interface PageContextType {
    screen: string;
}

export const PageContext = createContext<PageContextType>({
    screen: 'Desktop'
});
